// extracted by mini-css-extract-plugin
module.exports = {"halfWidth":"styles_halfWidth__1D7Nf","fullWidth":"styles_fullWidth__10Vi7","label":"styles_label__UFMKw"};